import React, { Component } from 'react';
import { intl } from '../../../../locales/localesConfig';

import TagsTextBoxSelector from './tagsTextBoxSelector';

class TagsSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: false,
    };
  }

  
  handleAddButtonClick = (event) => {
    if(!this.state.showInput) {
      this.setState({ showInput: true });
    }
  }

  render() {
    const {
      id,
      className,
      values,
      options,
      onClickOption,
      valueAccesor,
      labelAccesor,
      searchLabelLocale,
      hideSelectedTags, // boolean: Hides the selected tags (blue ribbons)
      hideTitle, // boolean: Hides the title "Tags" and the add button
      useSimpleSelect, // boolean: Uses a simple select instead of the SelectWithTextBoxInput
      disableOnKeyEnterAction, // boolean: Disables the action when pressing enter
      disabled,
    } = this.props;
    const dataPath = this.props["data-path"];
    
    return (
      <div className={"custom-input tags-input" + (className ? " " + className : "")}>
        <div className="tags_selector_row autocomplete-input">
          {!hideTitle && (
            <div className="tags_title_label">
              {intl.formatMessage({ id: "common.entity.tagSelectorTitle"})}
              {!disabled && <i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>}
            </div>
          )}
          {(!useSimpleSelect && (this.state.showInput || hideTitle)) && (
            <TagsTextBoxSelector
              id={id}
              values={values}
              onClickOption={onClickOption}
              addSelectLocale={searchLabelLocale ? searchLabelLocale : intl.formatMessage({ id: "common.entity.addTagSelectLabel"})}
              options={options}
              data-path={dataPath}
              allowDisplayOptionsButton={true}
              disableOnKeyEnterAction={disableOnKeyEnterAction}
              disabled={disabled}
            />
          )}
        </div>
        {!hideSelectedTags && (
          <div className="selected_tags_wrapper">
            {values && values.map((item,i) => {
                return (
                  <div key={i} className="tag_item">
                    <div className="tag_item_inner" title={item}>{item}</div>
                    <div className="tag_item_actions">
                      <i 
                        className="fas delete-action fa-times"                          
                        data-index={i}
                        data-delete={"true"}
                        data-tagslist={"true"}
                        data-path={dataPath}
                        onClick={onClickOption}
                      />
                    </div>
                  </div>
                );           
            })}
          </div>
        )}
      </div>
    );
  }
}

export default TagsSelector;





// WEBPACK FOOTER //
// ./source/client/components/common/inputs/tagsSelector.jsx